<template>
  <!-- Header Link -->
  <li class="nav-item m-0 py-0 w-100">
    <router-link tag="a" :class="linkClass" :to="{name: page.name}">
      {{ linkTitle }}
    </router-link>
  </li>
</template>

<script>
export default {
  name: "ApplicationMenuLink",
  props: {
    page: { type: Object, default: () => {} }
  },
  computed: {
    linkClass() {
      return this.prefixStringKey(this.page, "linkTheme", {
        prefix: "nav-link  py-2 nav-link-",
        defaut: "nav-link  py-2 nav-link-primary"
      });
    },
    linkTitle() {
      return this.getKey(
        this.page,
        "title",
        this.getKey(this.page, "name", "OUPS !")
      );
    }
  }
};
</script>
<style scoped>
  .nav-pills .nav-item > .nav-link:not(.active):not(:active){
    background-color: transparent;
  }
</style>